module.exports = __webpack_public_path__ + "img/laurent_voulzy-lv.b07668f7.jpg";